function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(11, 11, 12)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'pink': 'rgb(237, 0, 142)','lime-green': 'rgb(201, 255, 23)','green': 'rgb(109, 217, 63)','blue': 'rgb(0, 178, 242)','orange': 'rgb(250, 117, 0)','mr-campfire-bobble': 'rgb(186, 35, 38)','mr-electric-bobble': 'rgb(84, 132, 191)','mr-marina-splash-bobble': 'rgb(147, 219, 250)','mr-winter-berries-bobble': 'rgb(168, 77, 132)','mr-lavender-fizz-bobble': 'rgb(171, 174, 237)','cream-beanie': 'rgb(207, 216, 227)','green-beanie': 'rgb(201, 255, 23)','mr-alpine-blue-bobble': 'rgb(21, 43, 211)','mr-milkshake-mix': 'rgb(245, 180, 174)',};

    this.images = {'mr-black-jacks': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_black_jacks2_swatch_120x.png?v=4961198906322002555")','mr-frost-bobble': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_frost_bobble_swatch_120x.png?v=2242526119605730112")','mr-pink-dip': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_pink_dip_swatch_120x.png?v=16449611462408303004")','mr-ocean-dip': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_ocean_dip_swatch_120x.png?v=14846709374343877577")','mr-arctic-blast': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_arctic_blast_swatch_120x.png?v=5604040245556189247")','mr-marshmallow': 'url("//www.mentalriders.co.uk/cdn/shop/files/mr_marshmallow_swatch_120x.png?v=5659187154610052794")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
